module.exports = __webpack_public_path__ + "pnskfsquadron/img/kr-slider-2.jpg?57d58418";